import { routes as auth } from './auth'
import { routes as customers } from './customers'
import { routes as contracts } from './contracts'
import { routes as licenses } from './licenses'
import { routes as plans } from './plans'
import { routes as packages } from './packages'
import { routes as security } from './security'
import { routes as dashboard } from './dashboard' // tem que ser o ultimo por causa do catchall

export default [
  ...auth,
  ...customers,
  ...contracts,
  ...licenses,
  ...plans,
  ...packages,
  ...security,
  ...dashboard
]



// WEBPACK FOOTER //
// ./src/app/routes.js